module.exports = __webpack_public_path__ + "static/banner-tablet-e416288262640218716baaffe98f0fc7.png";